import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useTemplatePageCategory from '@hooks/useTemplatePageCategory'

import { TemplatePageCategoryModel } from '@models/types'

interface ActionsProps {
  templatePageCategory: TemplatePageCategoryModel,
}

const Actions = (props: ActionsProps) => {
  const { templatePageCategory: initTemplatePageCategory } = props

  const payload = useTemplatePageCategory(initTemplatePageCategory)

  const {
    callbacks: {
      createOrEditTemplatePageCategory,
      deleteTemplatePageCategory: deleteFn,
    },
    templatePageCategory: { hidden },
  } = payload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: { deleteString: 'archive' as const, entityName: 'Template Category' },
  }

  return (
    <Box justifyContent="center">
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        marginRight={hidden ? 0 : 'medium'}
        onClick={() => createOrEditTemplatePageCategory()}
        type="edit"
      />

      {!hidden && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
      )}
    </Box>
  )
}

export default Actions
